module.exports = __webpack_public_path__ + "img/ordPrimer1.be6695b2.jpg";